<template>
  <el-table
      :data="tableData"
      @selection-change="handleSelectionChange"
  >
    <el-table-column type="selection" width="50"></el-table-column>

    <el-table-column type="index" width="50"></el-table-column>

    <el-table-column prop="subEdition" :label="$t('lang.子品牌版本号')"></el-table-column>
    <el-table-column prop="productSubModel" :label="$t('lang.适配型号')"></el-table-column>
    <el-table-column prop="fileSize" :label="$t('lang.文件大小')">
      <template slot-scope="scope">
        <span>{{scope.row.fileSize | filterSize}}</span>
      </template>
    </el-table-column>

    <el-table-column prop="subBrandNumber" :label="$t('lang.子品牌编号')"></el-table-column>
    <el-table-column prop="subBrandName" :label="$t('lang.子品牌名称')"></el-table-column>
    <el-table-column prop="createTimeStr" :label="$t('lang.创建时间')"></el-table-column>
    <el-table-column prop="releaseTimeStr" :label="$t('lang.发布时间')"></el-table-column>
    <el-table-column prop="testStatusName" :label="$t('lang.测试状态')"></el-table-column>
    <el-table-column prop="releaseStatusName" :label="$t('lang.上线状态')"></el-table-column>
    <el-table-column prop="apply_time" :label="$t('lang.已安装设备数')"></el-table-column>

    <el-table-column fixed="right" :label="$t('lang.操作')" width="390">
      <template slot-scope="scope">
        <el-button size="mini" @click='$router.push({path: "/apk-detail",query: {code: scope.row.code} });' plain  type="primary">
          {{ $t('lang.查看') }}</el-button>
        <el-button size="mini" @click='handleDownLoadFile(scope.row)' plain type="success">{{ $t('lang.下载') }}</el-button>
        <el-button size="mini" @click='handleChangeTest(scope.row)' plain type="warning">{{ scope.row.testStatus != 'running' ? $t('lang.发布测试') : $t('lang.取消测试') }}</el-button>
        <el-button size="mini" @click='handleChangeRelease(scope.row)' plain type="success">{{scope.row.releaseStatus != 'release' ? $t('lang.发布上线') : $t('lang.取消上线')}}</el-button>
        <el-button size="mini" @click='handleDelete(scope.row)' plain type="danger">{{ $t('lang.删除') }}</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import {downloadFile} from "../../js/common";

export default {
  name: "AuditTable",
  props: {
    tableData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    handleSelectionChange(selection) {
      this.$emit('selection-change', selection)
    },

    handleDelete(row) {
      this.$emit('delete', row);
    },

    handleDownLoadFile(row) {
      downloadFile(this, row.fileCode);
    },
    handleChangeTest(row) {
      this.$emit('changeTest', row);
    },
    handleChangeRelease(row) {
      this.$emit('changeRelease', row);
    }
  }
}
</script>

<style scoped>

</style>
